import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Input,
  Badge,
  Typography,
  Col,
  Dropdown,
  Tooltip,
  Spin,
  Row,
} from "antd";
import {
  SearchOutlined,
  ReloadOutlined,
  CloseOutlined,
  SendOutlined,
  DownOutlined,
  CheckOutlined,
  RightOutlined,
} from "@ant-design/icons";

import "./Messages.css";
import "../../../../styles/GlobalStyle.css";
import { ReactComponent as OfferIcon } from "../../../../assests/offer-icon.svg";
import { ReactComponent as ChatSendIcon } from "../../../../assests/chat-send-icon.svg";
import TermsRequestPanel from "./TermsRequestPanel";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCampaignsForPurchase } from "../../../../store/thunks/buyer-thunks/BuyerThunks";
import ChatMsgPad from "../../../../components/common/chat-communication/ChatMsgPad";
import { getChatHistory } from "../../../../store/thunks/common-thunks/commonThunk";
import { formatToUSCurrency } from "../../../../components/common/utils/Utils";
const { Text } = Typography;

const Messages = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const negotiationFromNavigation = location.state?.negotiation;
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const [message, setMessage] = useState("");
  const [isTermsRequestOpen, setIsTermsRequestOpen] = useState(false);
  const [termsType, setTermsType] = useState("default");
  const [optimisticTermsMessage, setOptimisticTermsMessage] = useState(null);
  const [approvedData, setApprovedData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [requestType, setRequestType] = useState("");
  const {
    purchaseCampaign,
    totalPriceDetails,
    termsDetails,
    isPaymentLoading,
    isLoading: campaignPurchaseLoader,
  } = useSelector((state) => state?.campaignpurchase);
  const { isNegotiationLoading } = useSelector(
    (state) => state?.negotiationTerms,
  );
  const userRole = useSelector((state) => state.login.userType);
  const { isdefaultBookingLoading } = useSelector(
    (state) => state?.defaultBookingTerms,
  );
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [productSearch, setProductSearch] = useState("");
  const [debouncedProductSearch, setDebouncedProductSearch] = useState("");
  const [latestMessage, setLatestMessage] = useState(null);
  const [isCounterBannerVisible, setIsCounterBannerVisible] = useState(true);
  const [scrollToLatestTrigger, setScrollToLatestTrigger] = useState(0);
  const [installments, setInstallments] = useState([
    {
      id: Date.now(),
      name: "Payment",
      date: null,
      percentage: 0,
    },
  ]);
  const [termsNote, setTermsNote] = useState("");
  const handleViewThread = () => {
    // Hide the counter-offer banner
    setIsCounterBannerVisible(false);
    // Trigger scroll inside ChatMsgPad
    setScrollToLatestTrigger((prev) => prev + 1);
  };
  const getBookingStatus = (status) => {
    switch (status) {
      case 2:
        return {
          label: "Approved",
          type: "agreed",
        };

      case 3:
        return {
          label: "Negotiating",
          type: "counter",
        };

      case 1:
      default:
        return {
          label: "Pending",
          type: "offer",
        };
    }
  };

  const isLoading =
    campaignPurchaseLoader ||
    isPaymentLoading ||
    isdefaultBookingLoading ||
    isNegotiationLoading;
  const getPaymentTerms = (product) => {
    const terms = [];
    if (Number(product?.stripe_percent) > 0) {
      terms.push(`${product.stripe_percent}% Upfront`);
    }
    if (Number(product?.net_15_percent) > 0) {
      terms.push("Net 15");
    }

    if (Number(product?.net_30_percent) > 0) {
      terms.push("Net 30");
    }

    if (Number(product?.net_45_percent) > 0) {
      terms.push("Net 45");
    }

    if (Number(product?.net_60_percent) > 0) {
      terms.push("Net 60");
    }

    if (Number(product?.net_90_percent) > 0) {
      terms.push("Net 90");
    }

    return terms.length > 0 ? terms.join(" · ") : "-";
  };
  const conversations =
    selectedCampaign?.booking_array?.map((product, index) => {
      const bookingStatus = getBookingStatus(product?.booking_terms_status);
      return {
        id: product?.id || product?._id || index,
        title: product?.title || "-",
        productId: product?.siteNo || product?.product_id || "-",
        status: bookingStatus.label,
        statusType: bookingStatus.type,
        listPrice:
          product?.offerpriceperselectedDates != null
            ? `$${Number(product.offerpriceperselectedDates).toLocaleString()}`
            : "-",

        terms: getPaymentTerms(product),
        originalProduct: product,
        campaignId: product?.campaign_id || selectedCampaign?.id,
        bookingId: product?.productbookingid || product?.id || product?._id,
      };
    }) || [];
  useEffect(() => {
    if (
      negotiationFromNavigation ||
      !selectedCampaign ||
      !conversations?.length
    ) {
      return;
    }

    setSelectedConversationId(conversations[0]?.bookingId);
  }, [selectedCampaign?.id, negotiationFromNavigation]);

  useEffect(() => {
    // This effect only handles navigation from "All Negotiations".
    // It does not affect normal campaign/product selection.
    if (
      !negotiationFromNavigation ||
      !selectedCampaign ||
      !conversations?.length
    ) {
      return;
    }
    const targetConversation = conversations?.find(
      (conversation) =>
        String(conversation?.campaignId) ===
          String(negotiationFromNavigation?.campaignId) &&
        String(conversation?.bookingId) ===
          String(negotiationFromNavigation?.bookingId),
    );
    if (targetConversation) {
      setSelectedConversationId(targetConversation.bookingId);
    }
  }, [selectedCampaign?.id, conversations, negotiationFromNavigation]);
  const selected =
    conversations?.find(
      (conversation) =>
        String(conversation?.bookingId) === String(selectedConversationId),
    ) || null;
  const sendMessage = () => {
    if (!message.trim()) return;
    setMessage("");
  };
  const [campaignDropdownOpen, setCampaignDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const selectedProduct = selected?.originalProduct;
  const bookingId =
    selected?.bookingId ||
    selectedProduct?.productbookingid ||
    selectedProduct?.id ||
    selectedProduct?._id;
  const productId = selectedProduct?.product_id;
  const campaignId = selected?.campaignId || selectedProduct?.campaign_id;
  const receiverUserId =
    userRole === "basic" && selectedProduct?.client_mongo_id;
  const { userId } = useSelector((state) => state.login);
  useEffect(() => {
    if (!purchaseCampaign?.length) {
      setSelectedCampaign(null);
      return;
    }
    const navigationCampaignId = negotiationFromNavigation?.campaignId;
    if (navigationCampaignId) {
      const matchedCampaign = purchaseCampaign.find((campaign) => {
        const hasMatchingProduct = campaign?.booking_array?.some(
          (product) =>
            String(product?.campaign_id || campaign?.id) ===
              String(navigationCampaignId) &&
            String(product?.productbookingid || product?.id || product?._id) ===
              String(negotiationFromNavigation?.bookingId),
        );
        return (
          String(campaign?.id) === String(navigationCampaignId) ||
          hasMatchingProduct
        );
      });
      if (matchedCampaign) {
        setSelectedCampaign(matchedCampaign);
        return;
      }
    }
    setSelectedCampaign((prev) => {
      const updatedCampaign = purchaseCampaign.find(
        (campaign) => campaign?.id === prev?.id,
      );
      return updatedCampaign || purchaseCampaign[0];
    });
  }, [purchaseCampaign, negotiationFromNavigation]);

  useEffect(() => {
    dispatch(getCampaignsForPurchase());
  }, [dispatch]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encodedCampaignId = params.get("campaignId");
    if (!encodedCampaignId || !purchaseCampaign?.length) {
      return;
    }
    try {
      const campaignId = atob(encodedCampaignId);
      const matchedCampaign = purchaseCampaign.find(
        (campaign) => String(campaign?.id) === String(campaignId),
      );
      if (matchedCampaign) {
        setSelectedCampaign(matchedCampaign);
        const firstProduct = matchedCampaign?.booking_array?.[0];
        setSelectedConversationId(
          firstProduct?.productbookingid ||
            firstProduct?.id ||
            firstProduct?._id ||
            null,
        );
      }
    } catch (error) {
      console.error("Invalid campaignId in URL:", error);
    }
  }, [location.search, purchaseCampaign]);
  useEffect(() => {
    if (!campaignId || !bookingId) return;
    dispatch(
      getChatHistory({
        campaignId: String(campaignId),
        bookingId: String(bookingId),
      }),
    );
  }, [dispatch, campaignId, bookingId]);
  const allProductsApproved =
    selectedCampaign?.booking_array?.length > 0 &&
    selectedCampaign.booking_array.every(
      (product) => product?.booking_terms_status == 2,
    );
  const selectedProductApproved = selectedProduct?.booking_terms_status == 2;
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedProductSearch(productSearch.trim());
    }, 300);

    return () => clearTimeout(timer);
  }, [productSearch]);
  const filteredConversations = conversations.filter((conversation) => {
    if (!debouncedProductSearch) return true;

    const searchValue = debouncedProductSearch.toLowerCase();

    return (
      String(conversation?.title || "")
        .toLowerCase()
        .includes(searchValue) ||
      String(conversation?.productId || "")
        .toLowerCase()
        .includes(searchValue)
    );
  });
  const isIncomingCounterOffer = (message) => {
    if (!message || message.sender !== "receiver") {
      return false;
    }
    let termsData = message.terms_data;
    if (typeof termsData === "string") {
      try {
        termsData = JSON.parse(termsData);
      } catch {
        return false;
      }
    }
    if (Array.isArray(termsData)) {
      if (termsData.some((term) => Number(term?.approval_status) == 1)) {
        return false;
      }
      return termsData.some(
        (term) => term?.request_type === "counter_terms_request",
      );
    }
    if (termsData && typeof termsData === "object") {
      if (Number(termsData?.approval_status) == 1) {
        return false;
      }
      return termsData?.request_type === "counter_terms_request";
    }
    return false;
  };
  const vendorName = selectedProduct?.vendor || "Vendor";
  const getInitials = (name = "") => {
    const vendorName = String(name || "").trim();
    if (!vendorName) {
      return "V";
    }
    const words = vendorName.split(/\s+/);
    if (words.length >= 2) {
      return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
    }
    return vendorName.substring(0, 2).toUpperCase();
  };
  const getAvatarColor = (name = "") => {
    const vendorName = String(name || "");

    const colors = [
      "#7C3AED",
      "#2563EB",
      "#059669",
      "#D97706",
      "#DB2777",
      "#0891B2",
      "#9333EA",
      "#EA580C",
    ];

    const hash = vendorName
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };
  const vendorInitials = getInitials(vendorName);
  const vendorAvatarColor = getAvatarColor(vendorName);
  const handleReviewProducts = (isSignIO = false) => {
    if (!selectedCampaign?.id) {
      return;
    }
    const encodedCampaignId = btoa(String(selectedCampaign.id));
    if (isSignIO) {
      navigate(
        `${userRole === "owner" ? "/seller" : "/buyer"}/campaign-payment?step=1`,
      );
      return;
    }
    navigate(
      `${userRole === "owner" ? "/seller" : "/buyer"}/campaign-payment?campaignId=${encodedCampaignId}`,
    );
  };

  return (
    <>
      <div className="messages-page">
        <div className="re-design-campaign-selection-row">
          <div className="messages-page-header ">
            <div className="">
              <div className="common-main-header-text">Messages</div>
              <Text className="location-grey-text-12">
                Communicate with sellers, send offers, and negotiate deals.
              </Text>
            </div>

            <div className="messages-header-actions">
              {userRole == "basic" && (
                <Col style={{ display: "flex", gap: "10px" }}>
                  <Button
                    className={
                      allProductsApproved
                        ? "common-button-green"
                        : "common-button-red"
                    }
                    onClick={() => handleReviewProducts(false)}
                  >
                    <span
                      className={
                        allProductsApproved
                          ? "review-products-count review-products-count-completed"
                          : "review-products-count"
                      }
                    >
                      {allProductsApproved ? <CheckOutlined /> : "1"}
                    </span>
                    <span
                      className={
                        allProductsApproved
                          ? "common-text-008236-14"
                          : "common-text-white-14"
                      }
                    >
                      Review Products
                    </span>
                  </Button>
                  <RightOutlined style={{ color: "#D1D5DC" }} />
                  <Button
                    className={
                      allProductsApproved
                        ? "common-button-red"
                        : "common-button-grey"
                    }
                    onClick={() => handleReviewProducts(true)}
                    disabled={!allProductsApproved}
                  >
                    <span
                      className={
                        allProductsApproved
                          ? "review-products-count"
                          : "review-products-count review-products-count-grey"
                      }
                    >
                      2
                    </span>
                    <span
                      className={
                        allProductsApproved
                          ? "common-text-white-14"
                          : "common-text-99A1AF-14"
                      }
                    >
                      Sign IO
                    </span>
                  </Button>
                </Col>
              )}
              <Col className="re-design-campaign-selection-col">
                <Dropdown
                  open={campaignDropdownOpen}
                  onOpenChange={setCampaignDropdownOpen}
                  trigger={["click"]}
                  dropdownRender={() => (
                    <div className="campaign-selection-dropdown">
                      {purchaseCampaign?.length > 0 ? (
                        purchaseCampaign.map((campaign, index) => (
                          <div
                            key={campaign?.id ?? index}
                            className={`campaign-dropdown-item ${
                              selectedCampaign?.id === campaign?.id
                                ? "selected-campaign"
                                : ""
                            }`}
                            onClick={() => {
                              const firstProduct = campaign?.booking_array?.[0];
                              setSelectedConversationId(
                                firstProduct?.productbookingid ||
                                  firstProduct?.id ||
                                  firstProduct?._id ||
                                  null,
                              );
                              setIsTermsRequestOpen(false);
                              setOptimisticTermsMessage(null);
                              setLatestMessage(null);
                              setSelectedCampaign(campaign);
                              setCampaignDropdownOpen(false);
                              const encodedCampaignId = btoa(
                                String(campaign?.id),
                              );
                              const params = new URLSearchParams(
                                location.search,
                              );
                              params.set("campaignId", encodedCampaignId);
                              navigate(
                                `${location.pathname}?${params.toString()}`,
                                {
                                  replace: true,
                                },
                              );
                            }}
                          >
                            <div className="campaign-dropdown-header">
                              <div>
                                <Text className="campaign-dropdown-name">
                                  {campaign?.name}
                                </Text>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="campaign-dropdown-empty">
                          No campaigns available
                        </div>
                      )}
                    </div>
                  )}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <Text className="complete-campaign-text common-action-items-text-black-14">
                      {selectedCampaign?.name || ""}
                    </Text>
                    <DownOutlined
                      className={
                        campaignDropdownOpen
                          ? "campaign-dropdown-arrow-open"
                          : ""
                      }
                    />
                  </div>
                </Dropdown>
                <Text className="complete-campaign-text common-action-items-text-grey">
                  {selectedCampaign?.booking_array?.length || 0} assets ·
                  Negotiate & Buy
                </Text>
              </Col>
            </div>
          </div>
        </div>
        {userRole === "basic" &&
          isCounterBannerVisible &&
          isIncomingCounterOffer(latestMessage) && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <div className="messages-counter-banner">
                <div className="messages-counter-content">
                  <ReloadOutlined />
                  <div className="messages-counter-text">
                    <Text className="common-sub-header-black-14">
                      Counter-offer received
                    </Text>
                    <Text className="common-text-1E2939-12">
                      Counter-offer received from the seller.
                    </Text>
                  </div>
                </div>

                <div className="messages-counter-actions">
                  <Button
                    className="messages-view-thread-button"
                    onClick={handleViewThread}
                  >
                    <span className="common-action-items-text-red">
                      View Thread
                    </span>
                  </Button>

                  <CloseOutlined
                    onClick={() => setIsCounterBannerVisible(false)}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
            </div>
          )}
        <div
          className={`messages-main-card common-card-styles ${
            isTermsRequestOpen ? "messages-main-card-with-terms" : ""
          }`}
        >
          <div
            className={`messages-conversation-list ${!isTermsRequestOpen ? "messages-conversation-list-width" : ""}`}
          >
            <div className="messages-search-wrapper">
              <Input
                prefix={<SearchOutlined />}
                placeholder="Search products..."
                className="messages-search-input"
                value={productSearch}
                onChange={(event) => setProductSearch(event.target.value)}
                allowClear
              />
            </div>
            <div className="messages-list-scroll">
              {filteredConversations.length > 0 ? (
                filteredConversations?.map((conversation) => {
                  const originalIndex = conversations?.findIndex(
                    (item) => item?.id === conversation?.id,
                  );
                  const productVendorName =
                    conversation?.originalProduct?.vendor || "Vendor";
                  const productVendorInitials = getInitials(productVendorName);
                  const productVendorAvatarColor =
                    getAvatarColor(productVendorName);
                  return (
                    <div
                      key={conversation?.id}
                      className={`messages-conversation-item ${
                        String(selectedConversationId) ===
                        String(conversation?.bookingId)
                          ? "messages-conversation-item-active"
                          : ""
                      }`}
                      onClick={() => {
                        setSelectedConversationId(conversation?.bookingId);
                      }}
                    >
                      <div className="messages-conversation-content profile-section-terms">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            alignContent: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "38px",
                              height: "38px",
                              minWidth: "38px",
                              borderRadius: "50%",
                              backgroundColor: productVendorAvatarColor,
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "13px",
                              fontWeight: 600,
                              textTransform: "uppercase",
                            }}
                          >
                            {productVendorInitials}
                          </div>
                        </div>
                        <div style={{ width: "100%" }}>
                          <div className="messages-conversation-title-row">
                            <Text className="common-text-1E2939-14-500 truncate">
                              {conversation?.title}
                            </Text>
                          </div>

                          <Text className="common-text-99a1af-12-500">
                            {conversation?.productId}
                          </Text>

                          <div className="messages-status-row">
                            {conversation?.statusType && (
                              <span
                                className={`offer-oval-shape-badge ${
                                  conversation?.statusType === "agreed"
                                    ? "asset-status-approved"
                                    : conversation?.statusType === "rejected"
                                      ? "asset-status-rejected"
                                      : ""
                                }`}
                              >
                                {conversation?.status}
                                {conversation?.statusType === "agreed" && " ✓"}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {conversation?.unread && (
                        <Badge
                          count={conversation.unread}
                          className="messages-unread-badge"
                          style={{ backgroundColor: "#d2042d" }}
                        />
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="messages-search-empty">
                  <Text className="common-text-99a1af-12">
                    No conversations found
                  </Text>
                </div>
              )}
            </div>
            <div className="messages-thread-help">
              <Text className="common-text-99a1af-12">
                In this thread you can:
              </Text>

              <ul>
                <li className="location-grey-text-12">
                  Send a structured offer
                </li>
                <li className="location-grey-text-12">
                  Counter seller proposals
                </li>
                <li className="location-grey-text-12">Request IO</li>
                <li className="location-grey-text-12">
                  Download Insertion Order
                </li>
              </ul>
            </div>
          </div>

          <div
            className={`middle-chat-container ${
              !isTermsRequestOpen ? "middle-chat-container-width" : ""
            }`}
          >
            {selected ? (
              <>
                <div className="messages-chat-header">
                  <div className="messages-chat-product">
                    <div style={{ width: "100%" }}>
                      {/* Dynamic Initial Avatar */}

                      <div className="messages-chat-title">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                            width: "50%",
                          }}
                        >
                          <div
                            style={{
                              width: "38px",
                              height: "38px",
                              minWidth: "38px",
                              borderRadius: "50%",
                              backgroundColor: vendorAvatarColor,
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "13px",
                              fontWeight: 600,
                              textTransform: "uppercase",
                            }}
                          >
                            {vendorInitials}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                            }}
                          >
                            <Text className="common-text-1E2939-14-500 truncates-65">
                              <Tooltip title={selected?.title}>
                                {selected?.title || "-"}
                              </Tooltip>
                            </Text>
                            <span
                              className={`offer-oval-shape-badge ${
                                selected?.statusType === "agreed"
                                  ? "asset-status-approved"
                                  : selected?.statusType === "rejected"
                                    ? "asset-status-rejected"
                                    : selected?.statusType === "counter"
                                      ? "asset-status-counter"
                                      : "asset-status-pending"
                              }`}
                            >
                              {selected?.status || "-"}
                            </span>
                          </div>
                        </div>

                        <Text className="common-text-99a1af-12-500">
                          {selected?.productId || "-"}
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="messages-product-summary">
                  <Text className="location-grey-text-12">
                    Price:{" "}
                    <strong>
                      {formatToUSCurrency(
                        selected?.originalProduct?.offerpriceperselectedDates,
                      )}
                    </strong>
                  </Text>
                  {/* <Text className="location-grey-text-12">
                    {selected?.terms || "-"}
                  </Text> */}
                </div>
                <ChatMsgPad
                  key={`${selectedCampaign?.id}-${campaignId}-${bookingId}-${productId}`}
                  bookingId={bookingId}
                  productId={productId}
                  campaignId={campaignId}
                  currentUserId={userId}
                  receiverUserId={receiverUserId}
                  selectedChatProduct={selected}
                  hideTermsActions={true}
                  optimisticTermsMessage={optimisticTermsMessage}
                  onLatestMessageChange={setLatestMessage}
                  scrollToLatestTrigger={scrollToLatestTrigger}
                  onMakeTermsRequest={(data) => {
                    setApprovedData(data);
                    setRequestType(
                      data?.requestType ||
                        data?.request_type ||
                        (data?.termsType === "custom"
                          ? "counter_terms_request"
                          : "terms_request"),
                    );
                    setIsTermsRequestOpen(true);
                    setTermsType(data?.termsType || "default");
                  }}
                  allProductsApproved={allProductsApproved}
                  selectedProductApproved={selectedProductApproved}
                  selectedCampaign={selectedCampaign}
                />
              </>
            ) : (
              <div className="messages-empty-state">
                <div className="messages-empty-icon">💬</div>

                <Text className="messages-empty-title">
                  Select a conversation
                </Text>

                <Text className="messages-empty-description">
                  Choose a product from the left to view messages and start
                  negotiating.
                </Text>
              </div>
            )}
          </div>
          {isTermsRequestOpen && (
            <TermsRequestPanel
              selected={selected}
              termsType={termsType}
              requestType={requestType}
              setTermsType={setTermsType}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              installments={installments}
              setInstallments={setInstallments}
              termsNote={termsNote}
              setTermsNote={setTermsNote}
              setIsTermsRequestOpen={setIsTermsRequestOpen}
              setOptimisticTermsMessage={setOptimisticTermsMessage}
              allProductsApproved={allProductsApproved}
              selectedProductApproved={selectedProductApproved}
              approvedData={approvedData}
              selectedCampaign={selectedCampaign}
              receiverUserId={receiverUserId}
            />
          )}
        </div>

        {/* MOBILE COMPOSER */}
        <div className="messages-mobile-composer">
          <Input
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            onPressEnter={sendMessage}
            placeholder="Type a message..."
            suffix={<SendOutlined onClick={sendMessage} />}
          />
        </div>
      </div>
      {isLoading && <Spin size="large" fullscreen />}
    </>
  );
};

export default Messages;
